// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IEmailCommunicationView } from './IEmailCommunicationView';
import {
    instanceOfIEmailCommunicationView,
    IEmailCommunicationViewFromJSON,
    IEmailCommunicationViewFromJSONTyped,
    IEmailCommunicationViewToJSON,
} from './IEmailCommunicationView';
import type { ILetterCommunicationView } from './ILetterCommunicationView';
import {
    instanceOfILetterCommunicationView,
    ILetterCommunicationViewFromJSON,
    ILetterCommunicationViewFromJSONTyped,
    ILetterCommunicationViewToJSON,
} from './ILetterCommunicationView';

/**
 * @type ICommunicationDtoView
 * 
 * @export
 */
export type ICommunicationDtoView = IEmailCommunicationView | ILetterCommunicationView;

export function ICommunicationDtoViewFromJSON(json: any): ICommunicationDtoView {
    return ICommunicationDtoViewFromJSONTyped(json, false);
}

export function ICommunicationDtoViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICommunicationDtoView {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIEmailCommunicationView(json)) {
        return IEmailCommunicationViewFromJSONTyped(json, true);
    }
    if (instanceOfILetterCommunicationView(json)) {
        return ILetterCommunicationViewFromJSONTyped(json, true);
    }

    return {} as any;
}

export function ICommunicationDtoViewToJSON(json: any): any {
    return ICommunicationDtoViewToJSONTyped(json, false);
}

export function ICommunicationDtoViewToJSONTyped(value?: ICommunicationDtoView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIEmailCommunicationView(value)) {
        return IEmailCommunicationViewToJSON(value as IEmailCommunicationView);
    }
    if (instanceOfILetterCommunicationView(value)) {
        return ILetterCommunicationViewToJSON(value as ILetterCommunicationView);
    }

    return {};
}

